export default function shortenContract(contract: string, length = 4) {
  if (!contract || contract.length < length) {
    return contract;
  }
  return contract.slice(0, 3) + '...' + contract.slice(37 + 4 - length, 50);
};